
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";
import Bus from "@/lib/Bus";
import { Next, Route } from 'vue-router';
import { Finder, IFinder } from "@/finder/IFinder";
//import { MasterData } from "@/store/MasterData";
//import Store from "@/store/Store";

const bus: Bus = new Bus().getBus();

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<PopupVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: PopupVue) => {  });
        },
        components: {  FinderVue } 
        })

export default class PopupVue extends Vue {
  
  prj_finder:IFinder=new Finder();
  active:boolean=false;

  async refresh() {
  }


  async mounted() {
    //bus.register("kalkulacja_selected", this.kalkulacja_selected);
    await this.refresh();
  }

  async beforeDestroy() {
    //bus.remove("kalkulacja_selected", this.kalkulacja_selected);
  }

  async enter() {
    this.active=true;
  }

  async leave() {
    this.active=false;
  }


}


